import { render } from "./StuckWorkWarningModal.vue?vue&type=template&id=244daa2a"
import script from "./StuckWorkWarningModal.vue?vue&type=script&lang=js"
export * from "./StuckWorkWarningModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__